import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createRecoveryCodeFailed, createRecoveryCodeSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createRecoveryCode(action) {
  try {
    const url = `${BACKEND_URL}/sessions/${action.payload?.id}/recovery-code`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    const data = yield getBodyJson(dataResponse, {});
    if (dataResponse.status === CREATED) {
      yield put(createRecoveryCodeSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      const payload = { ...data, status: dataResponse.status };
      yield put(createRecoveryCodeFailed(payload));
      yield call(rejectActionPromise(action, payload));
    }
  } catch (e) {
    yield put(createRecoveryCodeFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
